class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    this.realButton = document.getElementById(this.dataset.submitTarget);
    this.realPrice = document.getElementById(this.dataset.priceSource);
    this.ownButton = this.querySelector('[data-sticky-atc-submit]');
    this.ownPrice = this.querySelector('[data-sticky-atc-price]');

    if (!this.realButton || !this.ownButton) return;

    this.ownButton.addEventListener('click', () => this.realButton.click());

    if (this.realPrice && this.ownPrice) {
      this.syncPrice();
      this.priceObserver = new MutationObserver(() => this.syncPrice());
      this.priceObserver.observe(this.realPrice, { childList: true, subtree: true, characterData: true });
    }

    this.syncButtonState();
    this.buttonObserver = new MutationObserver(() => this.syncButtonState());
    this.buttonObserver.observe(this.realButton, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
      characterData: true,
    });

    this.visibilityObserver = new IntersectionObserver(
      (entries) => {
        const isRealButtonVisible = entries[0].isIntersecting;
        this.classList.toggle('is-visible', !isRealButtonVisible);
        document.body.classList.toggle('sticky-atc-active', !isRealButtonVisible);
      },
      { threshold: 0 }
    );
    this.visibilityObserver.observe(this.realButton);
  }

  disconnectedCallback() {
    this.priceObserver?.disconnect();
    this.buttonObserver?.disconnect();
    this.visibilityObserver?.disconnect();
    document.body.classList.remove('sticky-atc-active');
  }

  syncPrice() {
    const visibleText = Array.from(this.realPrice.querySelectorAll('*'))
      .filter((node) => node.children.length === 0 && node.textContent.trim() !== '')
      .filter((node) => node.offsetParent !== null && !node.closest('.visually-hidden'))
      .map((node) => node.textContent.trim())
      .join(' ');
    this.ownPrice.textContent = visibleText.replace(/\s+/g, ' ').trim();
  }

  syncButtonState() {
    this.ownButton.disabled = this.realButton.disabled;
    const label = this.realButton.querySelector('span')?.textContent.trim();
    if (label) this.ownButton.textContent = label;
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
